import React, {
    ReactNode,
    createContext,
    useContext,
} from 'react';

import { Location } from "../../../API";

interface LocationsContext {
    locations: Array<Location>;
    createLocation?: (locationName: string, locationImages?: Blob[]) => (void | Promise<void>);
    editLocation?: (locationId: string, locationName: string) => (void | Promise<void>);
    deleteLocation?: (locationId: string) => (void | Promise<void>);
}

const LocationContext = createContext<LocationsContext | undefined>(undefined);

export const LocationsContextProvider: React.FC<{ children: ReactNode; value: LocationsContext; }> = ({ children, value }) => {
    return (
        <LocationContext.Provider value={value}>
            {children}
        </LocationContext.Provider>
    );
};

export const useLocations = (): LocationsContext => {
    const context = useContext(LocationContext);
    if (!context) {
        throw new Error('useLocation must be used within a LocationContextProvider');
    }
    return context;
};
